import {ACTION_CODE} from './_actionCode';
import {DealLossMotivesService} from '../../services';
import {ErrorModel, ResultModel} from '../../models';
import {LoggerService} from '../../services';
const FUNCTION_CODE = 'CREATE_DEALLOSSMOTIVE';

export async function createDealLossMotive(userData: Record<string, any>, dealLossMotive: Record<string, any>) {
    try {
        LoggerService.logInfo('Action - createDealLossMotive - Start');

        const createDealLossMotiveResult = await DealLossMotivesService.createDealLossMotive(userData, dealLossMotive);

        LoggerService.logInfo('Action - createDealLossMotive - End - Success');

        return ResultModel.newSuccessResult(createDealLossMotiveResult);
    }
    catch (error) {
        LoggerService.logInfo('Action - createDealLossMotive - End - Error');

        const newErr = ErrorModel.newError({
            code: `${ACTION_CODE}/${FUNCTION_CODE}/ERROR`,
            message: 'Une erreur est survenue lors de la création d‘une banque.',
            error: error
        });
        LoggerService.logError(error);

        return ResultModel.newErrorResult(newErr);
    }
}
